<template>
    <validation-provider :rules="rules"
                         v-slot="{ errors, classes }"
                         tag="div"
                         :mode="mode"
    >
        <input :type="type"
               :placeholder="placeholder"
               v-model="value"
               :value="value"
               :class="classes"
               @input="$emit('input', value)"
        >
        <span>{{ errors[0] }}</span>
    </validation-provider>
</template>


<script>
    import {ValidationProvider} from 'vee-validate'

    export default {
        name: "UniInput",
        components: {
            ValidationProvider
        },
        props: {
            id: String,
            type: {
                type: String,
                default: 'text',
            },
            placeholder: {
                type: String,
                default: '',
            },
            rules: String,
            mode: String,
            required: Boolean,
            val: String
        },
        data() {
            return {
                value: '',
            }
        },
        mounted(){
            this.value = this.val
        }
    }


</script>

<style scoped lang="scss">
    input {
        outline: none;
        border: 1px solid var(--color-grey-light-1);
        padding: 14px var(--s-xs);
        font-size: 1rem;
        line-height: 1rem;
        border-radius: var(--radius-default);
        width: 100%;
        transition: var(--transition-quick);
        display: block;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        background: none;
        color: var(--color-accent);

        &.invalid {
            border: 1px solid var(--color-warning);

            &:focus, &:hover {
                border: 1px solid var(--color-warning);
            }
        }

        &::placeholder {
            opacity: .5;
            color: var(--color-typo);
            font-size: 1rem;
            line-height: 1rem;
        }

        &:hover {
            border: 1px solid var(--color-primary-light-1);
        }

        &:focus {
            border: 1px solid var(--color-primary);
        }
    }

    span {
        color: var(--color-warning-dark);
    }


</style>
